import React from 'react';
import { useHistory } from 'react-router-dom';
import error from '../../../assets/images/error.svg';
import BackToHome from '../BackToHome/BackToHome';

function Error() {
  const history = useHistory();
  const redirect = () => {
    history.push('/');
  };

  const refresh = () => {
    window.location.reload();
  };

  return (
    <div>
      <div className="fail_container">
        <div className="failImg_container">
          <img className="failImg" src={error} />
        </div>
        <div className="error_subContainer">
          <div>
            <span className="failTitle">OOPS! Something went wrong </span>
          </div>
          <div className="failText_container">
            <span className="failText">
              You may also refresh the page or try again later.
            </span>
          </div>
          <div>
            <BackToHome title="Refresh the page" action={refresh} />
            {/* <BackToHome title="Back to Homepage" action={redirect} /> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Error;
